import { spring, presets } from 'react-motion';

export const defaultSpring = value => {
  return spring(value);
};

export const gentleSpring = value => {
  return spring(value, presets.gentle);
};

export const wobblySpring = value => {
  return spring(value, presets.wobbly);
};

export const stiffSpring = value => {
  return spring(value, presets.stiff);
};
